import { createContext } from "react";

import type { VideoCallContextValue } from "./VideoCallContextValue";

export const VideoCallContext = createContext<VideoCallContextValue | null>(null);

VideoCallContext.displayName = "VideoCallContext";
